export default "__VITE_ASSET__DSOfpXN2__"